<template>
  <div id="archive-stockings">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('navbar.archive_oversea_shipment')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="partners.find(p => p.id === partner_id) || ''"
              :options="partners"
              label="name"
              :placeholder="translations('arrival.supplier')"
              id="partner_id"
              @input="changedPartner">
            </v-select>
          </div>
          <div class="form-group d-flex align-items-center flex-wrap">
            <span class="text-nowrap mr-1">{{ translations('common.period') }}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
          </div>
        </div>
        <div class="form-group" style="margin: 1px 0 0 0">
          <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: translations('purchase.arrival_date'), value: 'arrived_at' },
            { text: translations('purchase.client_order_number'), value: 'po_no' },
            { text: translations('purchase.supplier'), value: 'partner_name' },
            { text: translations('purchase.total_amount'), value: 'total_amount' },
            { text: translations('purchase.order_date'), value: 'po_date' },
            { text: translations('purchase.warehouse'), value: 'warehouse_name' },
          ]"
          :items="stockings"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(stocking, i) in items" :key='i' data-href="" @click="openSinglePurchaseOverseas(stocking)">
                  <td>{{i + 1}}</td>
                  <td>{{ $invoiceTools.formatDate(stocking.arrived_at) }}</td>
                  <td>{{ stocking.po_no }}</td>
                  <td>{{ stocking.partner_name }}</td>
                  <td class="left">{{ stocking.total_amount.toLocaleString() }}</td>
                  <td>{{ $invoiceTools.formatDate(stocking.po_date) }}</td>
                  <td>{{ stocking.warehouse_name }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
      <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchivePurchaseOverseasStockings',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      dtSearch: '',
      isSearching: false,
      partner_id: 0,
      dateFrom: '',
      dateTo: '',
      stockings: [],
      isEmpty: false,
      isEmptyMsg: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    partners () {
      return this.$store.getters['Master/getPayOverseasTo']
    }
  },
  watch: {
    // partner_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountPurchaseOverseasStockings')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkPayOverseasTo')
    const storedFilter = this.$storage.get('ArchivePurchaseOverseasFilter')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.partner_id = storedFilter.partner_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   this.$storage.set('ArchivePurchaseStockings:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList (field, val) {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('purchase_overseas_stocking_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))
      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchaseOverseasFilter', params)
      console.log('ArchivePurchaseOverseasFilter:getFilterdList: ', params)

      this.$http.post(this.$api_url.purchase_overseas_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.stockings = result.list
          localStorage.setItem('visitCountPurchaseOverseasStockings', this.stockings.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.stockings = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchaseOverseas:getFilterdList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSinglePurchaseOverseas (stocking) {
      this.$router.push({ name: 'single-purchase-overseas-stockings', query: { purchase_id: stocking.id, purchase: JSON.stringify(stocking) } })
    },

    changedPartner (event) {
      if (!event) {
        this.partner_id = 0
        return
      }
      this.partner_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))
      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchaseOverseasFilter', params)
      console.log('ArchivePurchaseOverseasFilter:exportCsv: ', params)

      this.$http.post(this.$api_url.purchase_overseas_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.stockings = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchaseOverseas:getFilterdList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        data.push([
          item.arrived_at,
          item.po_no,
          item.partner_name,
          item.total_amount,
          item.po_date,
          item.warehouse_name
        ])
      })

      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('purchase.arrival_date'),
          this.translations('purchase.client_order_number'),
          this.translations('purchase.supplier'),
          this.translations('purchase.total_amount'),
          this.translations('purchase.order_date'),
          this.translations('purchase.warehouse')
        ],
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('purchase.overseas_purchases_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-stockings_wrapper .col-sm-12{
  padding-right: 0 !important;
}
#tbl-stockings_wrapper table.dataTable {
  margin-top: 0 !important;
}
</style>
